import type { Locale } from '../services/news';

export const CONTACT_CAPTCHA_URL = '/api/contact/captcha.php';
export const CONTACT_SUBMIT_URL = '/api/contact/submit.php';

export const CONTACT_PHONE_E164 = '447849923593';
export const TELEGRAM_URL = `https://t.me/+${CONTACT_PHONE_E164}`;
export const WHATSAPP_URL = `https://wa.me/${CONTACT_PHONE_E164}`;

const GOOGLE_MAP_EMBED =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8207764870953!2d103.84529831475365!3d1.2789780619879413!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da199b6c7d4e53%3A0x5c8e4a3fc75e6b7a!2s160%20Robinson%20Rd%2C%20Singapore%20068914!5e0!3m2!1sen!2ssg!4v1693000000000!5m2!1sen!2ssg';

/** 高德地图（中国大陆可访问） */
const AMAP_EMBED =
  'https://m.amap.com/search/mapview/keyword=160%20Robinson%20Road%2C%20Singapore%20068914';

export function resolveContactLocale(input?: string): Locale {
  const lang = (input ?? 'zh-CN').toLowerCase();
  if (lang.startsWith('en')) return 'en';
  if (lang.startsWith('zh-tw') || lang.startsWith('zh-hk')) return 'zh-TW';
  return 'zh-CN';
}

export function getMapEmbedUrl(locale: Locale): string {
  return locale === 'en' ? GOOGLE_MAP_EMBED : AMAP_EMBED;
}
